// Human-friendly labels for known fields, with a generic fallback
// formatter for anything not explicitly listed — so new fields on
// new endpoints are still readable without a code change.

const FIELD_LABEL_OVERRIDES = {
  id: "ID",
  account: "Account No.",
  connection: "Connection No.",
  category: "Category",
  old_mtr_serial: "Old Meter Serial",
  new_mtr_serial: "New Meter Serial",
  account_status: "Account Status",
  customer_name: "Customer Name",
  walk_route: "Walk Route",
  meter_size: "Meter Size",
  old_x_lon: "Old Longitude",
  old_y_lat: "Old Latitude",
  new_x_lon: "New Longitude",
  new_y_lat: "New Latitude",
  old_mtr_url: "Old Meter Photo",
  new_mtr_url: "New Meter Photo",
  replaced: "Replacement Status",
  comments: "Comments",
  enumerator: "Enumerator",
  createdAt: "Date Created",
  updatedAt: "Last Updated",
  status: "Status",
  subcounty: "Subcounty",
};

export function humanizeFieldName(field) {
  if (FIELD_LABEL_OVERRIDES[field]) return FIELD_LABEL_OVERRIDES[field];
  return field
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .trim();
}